<app-base-modal
  [title]="keyTestModalResourceType.name"
  [showStateToggle]="isValid()"
>
  <div class="key-test-wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (keyTestForm of keyTestFormGroups(); track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Ключ {{ getTitleAccordion($index) }} - {{ keyTestsData()[$index].title }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-key-test-header
            [parentData]="parentData()"
          />
          <app-key-test-form
            [noteId]="noteId()"
            [keyTestForm]="keyTestForm"
            [keyTestData]="keyTestsData()[$index]"
            [noFirstData]="noFirstData()"
            [isEditModeActive]="isEditModeActive"
            (updateData)="handleUpdateData($event, $index)"
            (deleteData)="handleDeleteData($index)"
          />
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      class="save-button"
      color="primary"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить ещё ключ
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
